import { render } from "./OffcanvasSplitBill.vue?vue&type=template&id=1917d7ff"
import script from "./OffcanvasSplitBill.vue?vue&type=script&lang=js"
export * from "./OffcanvasSplitBill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__